import styled from "styled-components";
import { Box } from "@mui/material";

export const Container = styled(Box)`
  width: 100%;
  height: ${(props) => (props.$canDrop ? "60px" : "10px")};
  transition: 200ms;
`;
